module.exports = __webpack_public_path__ + "images/PhoneSystem-6514451a2b8289bfd4017ec2cd598d3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/screenshots/PhoneSystem.png
// module id = ZUyj
// module chunks = 0